export default "__VITE_ASSET__CUAosAKv__"